<template>
    <div class="winners-page-products-container">
        <div class="winners-page-product" v-for="(product, index) in products" :key="index">
            <div class="winners-page-product-title-container">
                <div class="winners-page-product-title-upper">
                    <div :style="product.flag_generico == 1 ? 'cursor: pointer' : ''" class="winners-page-product-title">
                        <span
                            class="material-icons-outlined winners-page-product-title-expand"
                            v-on:click="toogleProduct(product)"
                            v-if="!product.isColapse"
                            >expand_more</span
                        >
                        <span
                            class="material-icons-outlined winners-page-product-title-expand"
                            v-on:click="toogleProduct(product)"
                            style="rotate: 270deg"
                            v-else
                            >expand_more</span
                        >
                        <span
                            v-if="irregular_amount(product)"
                            class="material-icons-outlined"
                            style="color: red"
                            title="Verificar quantidades"
                            >error</span
                        >
                        <div
                            @click="$emit('show-modal-brands', product)"
                            :style="product.flag_generico == 1 ? 'border-bottom: var(--primary-color) 1px solid' : ''"
                        >
                            {{ product.descricaoProduto }}
                        </div>
                        <div v-if="product.flag_generico == 0">
                            &nbsp;
                            <span @click="$emit('show-generic-zero-modal-brands', product)" class="material-icons-outlined settings-icon">
                                settings
                            </span>
                        </div>
                    </div>
                    <div class="winners-page-product-quantity">
                        Quantidade:{{ product.quantidadeCotacao ? product.quantidadeCotacao : 0 }}
                        {{ product.unidade_compra }}
                    </div>
                </div>
                <div v-if="product.codEan > 500000" class="winners-page-product-title-lower">Código: {{ product.codEan }}</div>
            </div>
            <div v-if="product.last_purchase" class="winners-page-product-info-container">
                <div class="winners-page-product-info-lastbuy">
                    <div>Dados da ultima compra:</div>
                </div>
                <div class="winners-page-product-info-lastbuy">Fornecedor: {{ product.last_purchase.for_nome }}</div>
                <div class="winners-page-product-info-lastbuy" v-if="product.last_purchase.pro_observacao">
                    Marca : {{ product.last_purchase.pro_observacao }}
                </div>
                <div class="winners-page-product-info-lastbuy">Data: {{ product.last_purchase.data_geracao | formatDateOnly }}</div>
                <div class="winners-page-product-info-lastbuy">Quantidade: {{ product.last_purchase.quantidade }}</div>
                <div class="winners-page-product-info-lastbuy">Valor: {{ formatPrice(product.last_purchase.valor) }}</div>
            </div>
            <div v-if="!product.isColapse">
                <div class="winners-page-product-info-table-header">
                    <div class="info-table-checkbox-width"></div>
                    <div class="info-table-suplier-width">Fornecedor</div>
                    <div class="info-table-brand-width">Marca</div>
                    <div class="info-table-payment-width">Forma De Pgto</div>
                    <div class="info-table-quantity-width">QTD. EMB.</div>
                    <div class="info-table-value-width">Valor unitário</div>
                    <div class="info-table-obs-width">Observação</div>
                    <div class="info-table-origem-width">Origem</div>
                    <div class="info-table-time-width">Horário</div>
                </div>
                <div
                    class="winners-page-product-info-table-row"
                    :class="getSpecialBackground(idx)"
                    v-for="(winner, idx) in product.vencedores"
                    :key="idx"
                >
                    <div class="info-table-checkbox-width info-table-suplier-width-colum winners-mobile-row">
                        <div class="winners-page-product-info-table-header-mobile"></div>
                        <div style="display:flex;">
                            <span
                                :title="getDisableTitle(winner)"
                                v-on:click.self="$emit('disable-checkbox', winner, product)"
                                v-if="is_winner(winner)"
                                class="material-icons-outlined"
                                :class="getDisableCheckBox(winner)"
                                style="
                                    color: var(--primary-color);
                                    cursor: pointer;
                                    margin-right: 10px;
                                    margin-left: 1vw;
                                "
                                >check_box</span
                            >
                            <span
                                :title="getDisableTitle(winner)"
                                v-on:click.self="$emit('disable-checkbox', winner, product)"
                                v-else
                                class="material-icons-outlined"
                                :class="getDisableCheckBox(winner)"
                                style="color: var(--primary-color); cursor: pointer; margin-left: 1vw"
                                >check_box_outline_blank</span
                            >
                            <img class="winners-loader" :class="{ hidden: !winner.is_loading }" src="/images/loader.svg" />
                            <span
                                v-if="is_winner(winner)"
                                :class="{ hidden: winner.is_loading }"
                                @click="$emit('open-sub-requests', winner, product)"
                                class="material-icons-outlined"
                                style="color: var(--primary-color); cursor: pointer"
                                >shopping_cart</span
                            >
                            <!-- <span v-if="is_winner(winner) && product.codEan > 500000" v-on:click="showProductInfo = product.codEan; buyPrice = winner.valor" class="material-icons-outlined" style="color: var(--primary-color); cursor: pointer; margin-left: 0.5vw;">local_offer</span> -->
                        </div>
                    </div>
                    <div class="info-table-suplier-width winners-mobile-row">
                        <div class="winners-page-product-info-table-header-mobile">Fornecedor</div>
                        {{ winner.nomeFornecedor }}
                        <span
                            @click="$emit('show-modal-brands', product, winner)"
                            v-if="winner.use_presets"
                            class="material-icons-outlined integration-icon"
                            title="Gerenciar configurações de digitação automática para outras marcas"
                        >
                            widgets
                        </span>
                    </div>
                    <div class="info-table-brand-width winners-mobile-row">
                        <div class="winners-page-product-info-table-header-mobile">Marca</div>
                        <div class="info-table-suplier-width-colum">
                            <span
                                v-on:click="$emit('set-preferencial', winner)"
                                v-if="winner.pro_preferencial == 1 && product.flag_generico == 1"
                                class="material-icons-outlined suplier-fav-icon"
                                >star</span
                            >
                            <span
                                v-on:click="$emit('set-preferencial', winner)"
                                v-if="winner.pro_preferencial == 0 && product.flag_generico == 1"
                                class="material-icons-outlined suplier-fav-icon"
                                >star_outline</span
                            >
                            <span
                                v-on:click.stop="$emit('open-manage-presets', product, winner)"
                                v-if="winner.use_presets"
                                class="material-icons-outlined integration-icon"
                                :style="winner.has_preset ? 'color: #4caf50' : ''"
                                title="Configuração de digitação automática"
                            >
                                smart_toy
                            </span>
                            {{ winner.pro_observacao }}
                        </div>
                    </div>
                    <div class="info-table-payment-width winners-mobile-row">
                        <div class="winners-page-product-info-table-header-mobile">
                            Forma De Pgto
                        </div>
                        {{ winner.forma ? winner.forma : "-" }}
                    </div>
                    <!-- <div class="info-table-quantity-width">{{product.flag_generico == 1 ? winner.embalagem : product.qtd_embalagem}}</div> -->
                    <div class="info-table-quantity-width winners-mobile-row">
                        <div class="winners-page-product-info-table-header-mobile">QTD. EMB.</div>
                        <div>
                            <input
                                v-if="product.flag_generico == 1"
                                type="number"
                                :style="checkSaved(winner, 'quantity')"
                                :id="'winner-quantity-' + index + '-' + idx"
                                v-on:keyup.enter="$emit('update-offer', winner, 'quantity', index, idx)"
                                class="info-table-input"
                                v-model.number="winner.quantidadeDigitacao"
                            />
                            <div v-else class="info-table-input">{{ winner.embalagem }}</div>
                        </div>
                    </div>
                    <div class="info-table-value-width winners-mobile-row">
                        <div class="winners-page-product-info-table-header-mobile">
                            Valor unitário
                        </div>
                        <div>
                            <money
                                v-bind="money"
                                :style="checkSaved(winner, 'value')"
                                :id="'winner-value-' + index + '-' + idx"
                                v-on:keyup.enter.native="$emit('update-offer', winner, 'value', index, idx)"
                                class="info-table-input"
                                v-model.number="winner.valor"
                            />
                        </div>
                    </div>
                    <div class="info-table-obs-width winners-mobile-row">
                        <div class="winners-page-product-info-table-header-mobile">Observação</div>
                        <div>
                            <input
                                class="info-table-input"
                                :style="checkSaved(winner)"
                                :id="'winner-obs-' + index + '-' + idx"
                                v-on:keyup.enter="$emit('update-offer', winner, 'obs', index, idx)"
                                type="text"
                                v-model="winner.observacao"
                            />
                        </div>
                    </div>
                    <div class="info-table-origem-width winners-mobile-row">
                        <div class="winners-page-product-info-table-header-mobile">Origem</div>
                        <span>{{ winner.origem_digitacao || "-" }}</span>
                    </div>
                    <div class="info-table-time-width winners-mobile-row">
                        <div class="winners-page-product-info-table-header-mobile">Horário</div>
                        <span title="Horário da digitação">{{ winner.data_digitacao | formatDate }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Money } from "v-money";

export default {
    components: { Money },
    props: {
        products: {
            type: Array,
            required: true,
        },
        money: {
            type: Object,
            required: true,
        },
    },
    emits: [
        "show-modal-brands",
        "show-generic-zero-modal-brands",
        "disable-checkbox",
        "open-sub-requests",
        "open-manage-presets",
        "set-preferencial",
        "update-offer",
    ],
    methods: {
        toogleProduct(product) {
            product.isColapse = !product.isColapse;
            this.$forceUpdate();
        },
        irregular_amount(product) {
            return product.flag_generico && product.soma_quantidades != product.quantidade_selecionada;
        },
        getSpecialBackground(idx) {
            if (idx % 2 != 0) return "page-table-line-special";
        },
        is_winner(winner) {
            if (winner.quantidade == 0 && winner.vencedor_quantidade == 0) return false;
            return winner.vencedor_quantidade > 0;
        },
        getDisableTitle(winner) {
            if (winner.qtdPedido > 0) return "Fornecedor com pedido gerado";
        },
        getDisableCheckBox(winner) {
            if (winner.qtdPedido > 0) return "disabled-check-box";
        },
        checkSaved(winner, text) {
            if (text == "quantity" && winner.isQuantitySaved) return "background-color: lightgreen";
            else if (text == "value" && winner.isValueSaved) return "background-color: lightgreen";
            else if (winner.isObsSaved) return "background-color: lightgreen";
        },
        formatPrice(value) {
            let val = (value / 1).toFixed(2).replace(".", ",");
            return "" + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
    },
};
</script>
<style lang="scss" scoped>
@import "../winners";
</style>
